import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { LocationChargePointListUpdateFormStep1SelectCell } from './location-charge-point-list-update-form-step-1-select.cell';
import { LocationChargePointListUpdateFormStep1SelectHeader } from './location-charge-point-list-update-form-step-1-select.header';

export const LocationChargePointListUpdateFormStep1SelectColumn: DisplayColumnDef<
  GatewayChargePointModel,
  unknown
> = {
  id: 'select',
  enableSorting: false,
  header: LocationChargePointListUpdateFormStep1SelectHeader,
  cell: LocationChargePointListUpdateFormStep1SelectCell,
};
